import styled from 'styled-components';
import { CommonDropdown, RegularButton } from 'pg-ui-library';

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-width: 500px;
  flex-direction: column;

  background-color: white;
  border-radius: 4px;
  padding: 25px;
`;

export const ContainerBody = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 800px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    min-width: 450px;
  }
`;

export const ViewFormsDropdrown = styled(CommonDropdown)``;

export const ViewFormsButton = styled(RegularButton)`
  align-self: flex-end;
  margin: 0;
`;
